import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "welcome-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-military-green-500 pretitle" }, "Welcome to Skyline"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-rust-500" }, "Create an account")
], -1)
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "mb-8 text-sm text-error-300",
  "data-testid": "error-message"
}
const _hoisted_6 = { class: "flex items-center text-sm" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Log in")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input_component = _resolveComponent("text-input-component")!
  const _component_p_link = _resolveComponent("p-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    class: "login-form-body"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_input_component, {
        id: "email",
        dataTestId: "email",
        helperText: "Email",
        placeholder: "Enter your email",
        value: _ctx.email,
        class: "w-full ml-2",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event)),
        textIcon: _ctx.Icon.MAIL
      }, null, 8, ["value", "textIcon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_text_input_component, {
        id: "password",
        dataTestId: "password",
        ref: "passwordInput",
        helperText: "Password",
        placeholder: "Enter your password",
        value: _ctx.password,
        class: "w-full ml-2",
        hideValue: true,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
        textIcon: _ctx.Icon.LOCK
      }, null, 8, ["value", "textIcon"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_text_input_component, {
        id: "confirm-password",
        dataTestId: "confirm-password",
        ref: "confirmPasswordInput",
        helperText: "Confirm password",
        placeholder: "Confirm your password",
        value: _ctx.passwordConfirm,
        class: "w-full ml-2",
        hideValue: true,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordConfirm = $event)),
        textIcon: _ctx.Icon.LOCK
      }, null, 8, ["value", "textIcon"])
    ]),
    (_ctx.error && _ctx.error !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        class: "text-rust-500",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_p_link, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_button_component, {
        disalbed: _ctx.isLoading,
        onClick: _ctx.signUp,
        class: "ml-auto",
        "data-testid": "submit-button",
        "color-type": "secondary",
        size: "large"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disalbed", "onClick"])
    ])
  ], 32))
}